import { Feature } from "../feature-checker.service";
import { FeatureFunction } from "../feature-function";
import { Injectable } from "@angular/core";

@Injectable()
export class CheckObjectFieldFunction implements FeatureFunction<boolean> {
    static readonly reference = 'CheckObjectFieldFeatureFunction';

    public apply(feature: Feature, object: any): Promise<boolean> {
        const found = (feature.metadata2 || '').split(/ *, */)
            .find(match => object?.[feature.metadata1] === match);
        return Promise.resolve(!!found);
    }
}
